import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="navbar">
        <div className="nav-inner">
          <div className="brand" onClick={toTop}>
            <Link
              onClick={toTop}
              to="/"
              aria-label="Home"
              className="brand-link"
            >
              Rivergrove
            </Link>
          </div>

          <nav
            className="main-nav"
            role="navigation"
            aria-label="Main navigation"
          >
            <ul className="nav-list">
              <li>
                <Link onClick={toTop} to="/shop">
                  Products
                </Link>
              </li>

              <li>
                <Link onClick={toTop} to="/about">
                  About
                </Link>
              </li>
              <li>
                <Link onClick={toTop} to="/contact">
                  Services
                </Link>
              </li>
            </ul>
          </nav>

          <div className="actions" role="group" aria-label="User actions">
            <Link
              onClick={toTop}
              to="/contact"
              className="action icon"
              aria-label="Help"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M9 9a3 3 0 1 1 6 0c0 2-3 2-3 4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <circle cx="12" cy="17" r="1.2" fill="currentColor" />
              </svg>
              <span className="label">Help</span>
            </Link>

            <Link
              onClick={toTop}
              to="/cartpage"
              className="action icon head-cartpage"
              aria-label="Cart"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 283.5 283.5"
                role="img"
                aria-label="My shopping bag"
                width={22}
                height={22}
              >
                <title>My shopping bag</title>
                <path d="M141.8 15.7c-30.3 0-46.2 14.2-46.2 41.1v4c0 1.1.9 2 2 2h5.9c.5 0 1-.2 1.4-.6.4-.4.6-.9.6-1.4v-4c0-21.6 11.2-31.2 36.3-31.2s36.3 9.6 36.3 31.2v4c0 .5.2 1 .6 1.4.4.4.9.6 1.4.6h5.9a2 2 0 0 0 2-2v-4c0-26.9-16-41.1-46.2-41.1z" />
                <path
                  fill="transparent"
                  d="M271.5 267H12a12 12 0 0 1-12-11.8l.1-1.5L20.6 81.3c.9-6.6 6.5-11.6 13.2-11.7h217.9c6.8.1 12.4 5.2 13.1 11.9l18.6 172.2c.8 6.5-3.9 12.4-10.4 13.2l-1.5.1z"
                />
                <path d="M271.5 267H12a12 12 0 0 1-12-11.8l.1-1.5L20.6 81.3c.9-6.6 6.5-11.6 13.2-11.7h217.9c6.8.1 12.4 5.2 13.1 11.9l18.6 172.2c.8 6.5-3.9 12.4-10.4 13.2l-1.5.1zM14.2 253.2h255.2L251.1 83.5H34.3L14.2 253.2z" />
              </svg>
              <span className="label">Cart</span>
              <span className="cart-count" aria-hidden="true">
                {cartItems?.length || 0}
              </span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
